export class BaseProvider
	prop parent

	get owner do parent.owner
	get repo do parent.repo
	get filePath do parent.filePath
	get ref do parent.ref
	get source do parent.source

	def constructor
		parent = $1
